import React from "react";
import styled from "styled-components";
import { color } from "../styles/theme";

interface ISubmit {
	text: string;
	onClick: any;
}

const Submit = ({ text, onClick }: ISubmit) => {
	return <SubmitBox onClick={() => onClick()}>{text}</SubmitBox>;
};

const SubmitBox = styled.button`
	width: 16rem;
	min-height: 4rem;
	border: 5px solid ${color.purple};
	border-radius: 6px;
	background: ${color.black};
	padding: none;
	margin: none;
	box-shadow: 0px 10px 0px 0px #431c5ea0;
	color: #fefffe;
	font-size: 1.5rem;
	font-weight: bold;
	letter-spacing: 0.3rem;
	cursor: pointer;

	&:hover {
		transition: 0.4s ease-in-out;
		margin-top: 9px;
		box-shadow: 0px 1px 0px 0px #431c5ea0;
	}
`;

export default Submit;
